module.exports = __webpack_public_path__ + "assets/img/20231230.cd55b950.png";